<template>
    <div
        data-testid="page:main:for-individuals"
        class="home-page no-overflow"
    >
        <MainSectionSlider :slides-data="modifySlides(homePageModel.slidesData)" />
        <ProfitPropositions />
        <div class="wrapper">
            <Services :useful-cards="homePageModel.usefulCards" />
            <TransferBanner />
        </div>
        <AdditionalWidgets />
        <PressReleases />
    </div>
</template>

<script>
import {defineComponent} from 'vue';

import {useSlidesModify} from '@/core/composables/useSlidesModify';
import * as HomePageModel from '@/core/models/pages/home-page/HomePageModel';

import PressReleases from '@/components/Pages/HomePage/PressReleases';
import MainSectionSlider from '@/components/Sliders/MainSectionSlider/MainSectionSlider.vue';
import ProfitPropositions from '@/components/Pages/HomePage/ProfitPropositions.vue';
import Services from '@/components/Pages/HomePage/Services.vue';
import AdditionalWidgets from '@/components/Pages/HomePage/AdditionalWidgets.vue';
import TransferBanner from '@/components/Pages/HomePage/TransferBanner.vue';

export default defineComponent({
    name: 'HomePage',
    components: {
        PressReleases,
        MainSectionSlider,
        ProfitPropositions,
        Services,
        AdditionalWidgets,
        TransferBanner,
    },
    setup() {
        const {modifySlides} = useSlidesModify();

        return {
            homePageModel: HomePageModel,
            modifySlides,
        };
    },
});
</script>

<style scoped lang="scss">
::v-deep .pension {
    .main-slider__value-name {
        font-size: 18px;

        @media screen and (max-width: $tablet) {
            font-size: 14px;
        }
    }

    .main-slider__col {
        margin-bottom: 8px;

        @media (width <= 540px) {
            margin-bottom: 0;
        }
    }
}

::v-deep .mortgage-common {
    .main-slider__col {
        margin-bottom: 8px;
    }
}

::v-deep .credit-for-all {
    .main-slider__cols-wr {
        justify-content: flex-start;
    }

    .main-slider__col:first-of-type {
        margin-right: 64px;
    }
}

::v-deep .deposit-banner {
    .main-slider__cols-wr.empty-value {
        margin-top: 0;
        margin-bottom: 24px;

        @media screen and (max-width: $tablet) {
            margin: 0;
        }
    }
}

::v-deep .transfers {
    &.main-slider__wrapper {
        justify-content: center;
    }

    .main-slider__content {
        margin-top: 0;

        @media (width <= 780px) {
            margin-top: 40px;
        }
    }

    .main-slider__cols-wr {
        margin-bottom: 48px;
    }
}

::v-deep .green-vector {
    .main-slider__title {
        margin-bottom: 24px;
    }
}
</style>
